import { render, staticRenderFns } from "./customMinip-list.vue?vue&type=template&id=245f38dc&scoped=true"
import script from "./customMinip-list.vue?vue&type=script&lang=js"
export * from "./customMinip-list.vue?vue&type=script&lang=js"
import style0 from "./customMinip-list.vue?vue&type=style&index=0&id=245f38dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f38dc",
  null
  
)

export default component.exports